import { render, staticRenderFns } from "./ElementDatePicker.vue?vue&type=template&id=1077b81c&scoped=true"
import script from "./ElementDatePicker.vue?vue&type=script&lang=js"
export * from "./ElementDatePicker.vue?vue&type=script&lang=js"
import style0 from "./ElementDatePicker.vue?vue&type=style&index=0&id=1077b81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1077b81c",
  null
  
)

export default component.exports